/*
  merce-popup.js — da ao pop-up de captacao o botao de fechar que o app nao entrega.
  Carregado por snippets/merce-popup.liquid. Leia o cabecalho de la antes de mexer.

  O pop-up e do app 1ClickPopup, nao do tema. O .dismissal dele vem vazio, sem
  icone e sem handler nesta conta: clicar nao faz nada, clique fora nao fecha e
  Esc nao fecha. O unico jeito de sair era rolar a pagina — no celular, uma parede.

  Este arquivo cria um X proprio e liga as tres saidas: o X, o clique fora e o Esc.
  Fechar usa o mecanismo do proprio app (tira a classe is__open do .modal); o
  display:none no overlay e so cinto de seguranca. Nao gravamos nada no
  localStorage — quem decide se o pop-up volta continua sendo a regra do app.

  NAO encosta no envio: o botao de submit fica dentro do .popup e nao casa com
  nenhuma das condicoes de fechar.
*/
(function () {
  // Idempotente: o Turbo recria o <body> a cada navegacao e o snippet roda de
  // novo. Os listeners ficam no document, que sobrevive as trocas de body.
  if (window.mercePopupFechar) return;
  window.mercePopupFechar = true;

  var HOST = 'oneclickpopup-widget';

  function host() { return document.querySelector(HOST); }

  function fechar() {
    var h = host();
    if (!h) return;
    var modal = h.querySelector('.modal');
    if (modal) modal.classList.remove('is__open');
    var overlay = h.querySelector('.overlay');
    if (overlay) overlay.style.setProperty('display', 'none', 'important');
  }

  function criarX() {
    var h = host();
    if (!h) return false;
    var popup = h.querySelector('.popup');
    if (!popup) return false;
    if (popup.querySelector('.merce-popup-x')) return true;

    // Se um dia o app passar a entregar o fechar dele de verdade (.dismissal
    // com conteudo), nao criamos um segundo X por cima.
    var d = popup.querySelector('.dismissal');
    if (d && d.children.length > 0) return true;

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'merce-popup-x';
    b.setAttribute('aria-label', 'Fechar');
    popup.appendChild(b);
    return true;
  }

  document.addEventListener('click', function (e) {
    var h = host();
    if (!h) return;
    if (e.target.closest && e.target.closest('.merce-popup-x')) {
      e.preventDefault();
      fechar();
      return;
    }
    var overlay = h.querySelector('.overlay');
    if (overlay && e.target === overlay) fechar();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') fechar();
  });

  // O widget do app monta depois, por script externo, entao procuramos por ele.
  // Sem MutationObserver em subtree, que dispararia a cada mudanca do DOM da
  // pagina inteira.
  //
  // RE-ARMADO A CADA NAVEGACAO DO TURBO, e isso importa: a busca dura 30s. Se o
  // visitante ficasse mais que isso na primeira pagina e o pop-up so disparasse
  // na seguinte (navegacao sem reload), o X nunca seria criado e o pop-up
  // voltaria a ser a parede sem saida que viemos consertar.
  var timer = null;

  function procurar() {
    if (timer) clearInterval(timer);
    var tentativas = 0;
    timer = setInterval(function () {
      tentativas++;
      if (criarX() || tentativas > 75) {
        clearInterval(timer);
        timer = null;
      }
    }, 400);
  }

  procurar();
  document.addEventListener('turbo:load', procurar);
})();